import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';
import { throwErrorWithResponse } from '../throwErrorWithResponse';

const ONBOARDING_KEY = 'onboarding-state:introWorkflow';

export const experimentalGetCompleteOnboarding: ExperimentalQueries['experimentalGetCompleteOnboarding'] =
	(_, { key = ONBOARDING_KEY }, { network }) =>
		fetchJSON(network, `/wiki/rest/onboarding/1/store?key=${key}`, {
			method: 'GET',
			headers: {
				'Content-Type': MediaType.JSON,
			},
		}).then(
			/* onFulfilled */ ({ value } = {}) => ({
				complete: value === '__complete__',
				key,
			}),
			/* onRejected */ (reason) => {
				const { response } = reason;
				if (response?.status == 401) {
					// Don't change the messages text here
					throwErrorWithResponse(Error('unauthorized'), response);
				}

				throw reason;
			},
		);
